import {createMuiTheme, responsiveFontSizes} from '@material-ui/core/styles'

const defaultTheme = createMuiTheme({
  typography: {
    // htmlFontSize sets size of 1rem for app
    htmlFontSize: 16,
    fontSize: 14,
    fontFamily: ['Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h1: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 300,
      fontSize: '5rem',
      lineHeight: 1.167,
      letterSpacing: '-0.01562em',
    },
    h2: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 300,
      fontSize: '3.75rem',
      lineHeight: 1.2,
      letterSpacing: '-0.00833em',
    },
    h3: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 400,
      fontSize: '3rem',
      lineHeight: 1.167,
      letterSpacing: '0em',
    },
    h4: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 400,
      fontSize: '2.125rem',
      lineHeight: 1.235,
      letterSpacing: '0.00735em',
    },
    h5: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: 1.334,
      letterSpacing: '0em',
    },
    h6: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.6,
      letterSpacing: '0.0075em',
    },
    body1: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: '0.00938em',
    },
    body2: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.43,
      letterSpacing: '0.01071em',
    },
    button: {
      fontFamily: "'Barlow Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.75,
      letterSpacing: '0.02857em',
      textTransform: 'uppercase',
    },
  },
  palette: {
    // color shades generated by https://material-ui.com/customization/color/#color playground
    primary: {
      light: '#dfdfea',
      main: '#233e62',
      dark: '#67678b',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ececf3',
      main: '#b6b6be',
      dark: '#7f7f9e',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    success: {
      light: '#81c784',
      main: '#4caf50',
      dark: '#417505',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    info: {
      light: '#64b5f6',
      main: '#2196f3',
      dark: '#1976d2',
      contrastText: '#fff',
    },
    warning: {
      light: '#ffb74d',
      main: '#ff9800',
      dark: '#f57c00',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    error: {
      light: '#e57373',
      main: '#f44336',
      dark: '#D0021B',
      contrastText: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
      paper: '#fff',
      default: '#fafafa',
    },
    work: '#8B572A',
    destination: '#7ED321',
    gas: '#4A90E2',
    service: '#FA6B19',
    accordionBackground: '#eeedf3',
  },
  // border radius of input fields and buttons
  shape: {
    borderRadius: 4,
  },
  // spacing sets size of padding and margin
  spacing: 4,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
})

const defaultThemeResponsive = responsiveFontSizes(defaultTheme)

export default defaultThemeResponsive
